// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__4f6-0","image":"Header_image___uUtp","name":"Header_name__FTviC","info":"Header_info__3XIg5","infoRow":"Header_infoRow__NyD52"};